module.exports = __webpack_public_path__ + "img/mail-box.17ea5ac8.svg";